(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-product-selling-plan-runtime"] && !Shopify.designMode) return;
  try {
    class TDProductSellingPlan extends HTMLElement {
    static SELECTORS = Object.freeze({
      productData: '[data-td-product-data]',
      config: '[data-td-config]',
      variantDiscounts: '[data-td-variant-discounts]',
      purchaseOption: '[data-td-purchase-option]',
      oneTime: '[data-td-one-time]',
      subscription: '[data-td-subscription]',
      scheduleOption: '[data-td-schedule-option]',
      planCard: '[data-td-plan-card]',
      sellingPlanInput: '[data-td-selling-plan-input]',
      mobileSelect: '[data-td-mobile-select]',
      mobileOption: '[data-td-mobile-option]',
      oneTimePrice: '[data-td-one-time-price]',
      oneTimeCompare: '[data-td-one-time-compare]',
      subscriptionPrice: '[data-td-subscription-price]',
      subscriptionSuffix: '[data-td-subscription-suffix]',
      startingLabel: '[data-td-starting-label]',
      mobileTitle: '[data-td-mobile-title]',
      mobileSaving: '[data-td-mobile-saving]',
      mobileDescription: '[data-td-mobile-description]',
      planPrice: '[data-td-plan-price]',
      planSaving: '[data-td-plan-saving]',
      planCompare: '[data-td-plan-compare]',
      planDaily: '[data-td-plan-daily]',
      planRecurring: '[data-td-plan-recurring]',
      perk: '[data-td-perk]',
      perkCopy: '[data-td-perk-copy]',
      mainCta: 'button[type="submit"][name="add"]',
      mainCtaSettings: '[data-td-show-price]',
      quantityInput: 'input[name="quantity"]',
      mainCtaContent: '.add-to-cart-text__content',
    });

    static CADENCE_PATTERNS = Object.freeze({
      30: [/every\s+(?:1\s+)?month/i, /monthly/i, /30\s*days?/i, /4\s*weeks?/i],
      90: [/every\s+3\s+months?/i, /3\s*months?/i, /90\s*days?/i, /quarter/i],
      180: [/every\s+6\s+months?/i, /6\s*months?/i, /180\s*days?/i, /half[-\s]?year/i],
      365: [/every\s+(?:12\s+months?|year)/i, /12\s*months?/i, /365\s*days?/i, /annual/i, /yearly/i],
    });

    abortController;
    animationFrame;
    product;
    config;
    plans;
    mainCtaButton;
    mainCtaOriginalContent;
    selectedAmount;
    lastSchedule = 'days_30';

    connectedCallback() {
      this.abortController = new AbortController();
      this.animationFrame = requestAnimationFrame(() => {
        this.animationFrame = undefined;
        this.initialize();
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      this.restoreMainCta();
    }

    initialize() {
      const productData = this.querySelector(TDProductSellingPlan.SELECTORS.productData)?.textContent;
      const configData = this.querySelector(TDProductSellingPlan.SELECTORS.config)?.textContent;
      const variantDiscountsData = this.querySelector(TDProductSellingPlan.SELECTORS.variantDiscounts)?.textContent;
      if (!productData || !configData) return;

      try {
        this.product = JSON.parse(productData);
        this.config = JSON.parse(configData);
        this.variantDiscounts = variantDiscountsData ? JSON.parse(variantDiscountsData) : {};
      } catch (error) {
        console.error('[td-product-selling-plan] Invalid product data.', error);
        return;
      }

      this.plans = this.buildPlans();
      this.updateAvailability();
      this.updatePlanDisplays();

      const { signal } = this.abortController;
      this.addEventListener('click', this.handleClick, { signal });
      this.addEventListener('change', this.handleChange, { signal });
      this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });

      const productForm = document.getElementById(this.dataset.tdProductFormId);
      productForm?.addEventListener('input', this.handleFormInput, { signal });
      productForm?.addEventListener('change', this.handleFormInput, { signal });

      const defaultSelection = this.dataset.tdDefaultSelection;
      const firstAvailableSub = this.firstAvailableSubscription();
      const firstExistingSub = this.firstExistingSubscription();
      if (defaultSelection === 'one_time' && this.plans.one_time.exists) {
        this.applySelection('one_time');
      } else if (this.plans[defaultSelection]?.exists) {
        this.applySelection('subscription', defaultSelection);
      } else if (firstAvailableSub) {
        this.applySelection('subscription', firstAvailableSub);
      } else if (this.plans.one_time.exists) {
        this.applySelection('one_time');
      } else if (firstExistingSub) {
        this.applySelection('subscription', firstExistingSub);
      } else {
        this.hidden = true;
      }
    }

    buildPlans() {
      const variants = this.product.variants || [];
      const oneTimeVariant = variants[0];
      const subscriptionPlans = Object.fromEntries(
        this.subscriptionKeys().map((key) => [key, this.buildSubscriptionPlan(key, this.config.plans[key], variants)])
      );

      return {
        one_time: {
          variant: oneTimeVariant,
          exists: Boolean(oneTimeVariant && !this.product.requires_selling_plan),
          available: Boolean(oneTimeVariant?.available && !this.product.requires_selling_plan),
          supply: 1,
        },
        ...subscriptionPlans,
      };
    }

    buildSubscriptionPlan(key, config, variants) {
      const match = this.findSellingPlanMatch(config, variants);

      return {
        key,
        ...config,
        variant: match?.variant,
        sellingPlan: match?.sellingPlan,
        allocation: match?.allocation,
        exists: Boolean(config.enabled && match),
        available: Boolean(config.enabled && match && match.variant.available),
      };
    }

    findSellingPlanMatch(config, variants) {
      if (!config?.enabled) return null;

      const sellingPlans = this.skioSellingPlans();
      const preferredVariant = variants[config.variantIndex];
      if (!preferredVariant) return null;

      const exactName = String(config.sellingPlanName || '').trim().toLowerCase();

      const allocationMatch = (preferredVariant.selling_plan_allocations || [])
        .map((allocation) => ({
          allocation,
          sellingPlan: sellingPlans.find(
            (plan) => String(plan.id) === String(allocation.selling_plan_id)
          ),
        }))
        .find(({ sellingPlan }) => {
          if (!sellingPlan) return false;
          return (
            String(sellingPlan.name || '').trim().toLowerCase() === exactName ||
            this.matchesCadence(sellingPlan, config.days)
          );
        });

      if (!allocationMatch?.sellingPlan) return null;

      return {
        sellingPlan: allocationMatch.sellingPlan,
        variant: preferredVariant,
        allocation: allocationMatch.allocation,
      };
    }

    skioSellingPlans() {
      return (this.product.selling_plan_groups || [])
        .filter((group) => String(group.app_id || '').toUpperCase() === 'SKIO')
        .flatMap((group) => group.selling_plans || []);
    }

    matchesCadence(sellingPlan, days) {
      const optionText = Array.isArray(sellingPlan.options)
        ? sellingPlan.options.flatMap((option) => [option.name, option.value]).filter(Boolean)
        : [];
      const planText = [sellingPlan.name, sellingPlan.description, ...optionText].filter(Boolean).join(' ');
      return (TDProductSellingPlan.CADENCE_PATTERNS[days] || []).some((pattern) => pattern.test(planText));
    }

    subscriptionKeys() {
      return Object.keys(this.config.plans || {});
    }

    firstAvailableSubscription() {
      return this.subscriptionKeys().find((key) => this.plans[key]?.available);
    }

    firstExistingSubscription() {
      return this.subscriptionKeys().find((key) => this.plans[key]?.exists);
    }

    updateAvailability() {
      const oneTime = this.querySelector(TDProductSellingPlan.SELECTORS.oneTime);
      if (oneTime) oneTime.hidden = !this.plans.one_time.exists;

      const hasSubscription = this.subscriptionKeys().some((key) => this.plans[key]?.exists);
      const subscription = this.querySelector(TDProductSellingPlan.SELECTORS.subscription);
      if (subscription) subscription.hidden = !hasSubscription;

      this.querySelectorAll(TDProductSellingPlan.SELECTORS.planCard).forEach((card) => {
        const key = card.dataset.tdPlanKey;
        const plan = this.plans[key];
        card.hidden = !plan?.exists;
      });

      this.querySelectorAll(TDProductSellingPlan.SELECTORS.mobileOption).forEach((option) => {
        const plan = this.plans[option.value];
        if (!plan?.exists) {
          option.remove();
          return;
        }
        option.disabled = false;
        option.hidden = false;
      });
    }

    updatePlanDisplays() {
      const oneTimeVariant = this.plans.one_time.variant;
      const oneTimeDisplayPrice = this.applyDiscountAmount(oneTimeVariant, oneTimeVariant?.price || 0);
      const oneTimeComparePrice = Number(oneTimeVariant?.compare_at_price) || 0;
      this.setText(TDProductSellingPlan.SELECTORS.oneTimePrice, this.formatMoney(oneTimeDisplayPrice));
      this.setText(TDProductSellingPlan.SELECTORS.oneTimeCompare, this.formatMoney(oneTimeComparePrice));

      const oneTimeCompare = this.querySelector(TDProductSellingPlan.SELECTORS.oneTimeCompare);
      if (oneTimeCompare) oneTimeCompare.hidden = oneTimeComparePrice <= oneTimeDisplayPrice;

      this.subscriptionKeys().forEach((key) => {
        const plan = this.plans[key];
        if (!plan.exists) return;

        const price = this.planPrice(plan);
        const comparePrice = this.compareAtPrice(plan);
        const saving = comparePrice > 0 ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
        const recurringPrice = this.sellingPlanPrice(plan);
        const recurringSaving = comparePrice > 0 ? Math.round(((comparePrice - recurringPrice) / comparePrice) * 100) : 0;
        const hasDiscount = this.discountAmount(plan.variant) > 0 && recurringPrice !== price;

        this.setDataText(TDProductSellingPlan.SELECTORS.planPrice, 'tdPlanPrice', key, this.formatMoney(price));
        this.setDataText(TDProductSellingPlan.SELECTORS.planSaving, 'tdPlanSaving', key, `${saving}%`);
        this.setDataText(TDProductSellingPlan.SELECTORS.planCompare, 'tdPlanCompare', key, this.formatMoney(comparePrice));
        this.setDataText(
          TDProductSellingPlan.SELECTORS.planDaily,
          'tdPlanDaily',
          key,
          `${this.formatMoney(price / plan.days)}/day`
        );
        this.querySelectorAll(TDProductSellingPlan.SELECTORS.planRecurring).forEach((element) => {
          if (element.dataset.tdPlanRecurring !== key) return;
          element.hidden = !hasDiscount;
          if (hasDiscount) {
            element.textContent = `${recurringSaving}% ${this.dataset.tdOffRecurringLabel} (${this.formatMoney(recurringPrice)}${plan.suffix})`;
          }
        });
      });
    }

    planPrice(plan) {
      return this.applyDiscountAmount(plan.variant, this.sellingPlanPrice(plan));
    }

    compareAtPrice(plan) {
      return Number(plan.variant?.compare_at_price) || 0;
    }

    sellingPlanPrice(plan) {
      if (plan.allocation?.price != null) return Number(plan.allocation.price);

      const adjustment = plan.sellingPlan?.price_adjustments?.[0];
      if (!adjustment) return plan.variant.price;

      if (adjustment.value_type === 'price') return adjustment.value;
      if (adjustment.value_type === 'fixed_amount') return plan.variant.price - adjustment.value;
      if (adjustment.value_type === 'percentage') {
        return Math.round(plan.variant.price * (1 - adjustment.value / 100));
      }

      return plan.variant.price;
    }

    applyDiscountAmount(variant, price) {
      return Math.max(0, Number(price) - this.discountAmount(variant));
    }

    discountEntryFor(variant) {
      return variant?.id != null ? this.variantDiscounts?.[variant.id] : null;
    }

    discountAmount(variant) {
      const entry = this.discountEntryFor(variant);
      const amount = parseFloat(entry?.amount);
      return Number.isFinite(amount) && amount > 0 ? Math.round(amount * 100) : 0;
    }

    handleClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const subscription = target.closest(TDProductSellingPlan.SELECTORS.subscription);
      if (!subscription || !this.contains(subscription)) return;

      const purchaseOption = subscription.querySelector(TDProductSellingPlan.SELECTORS.purchaseOption);
      if (
        purchaseOption?.checked ||
        target.closest(TDProductSellingPlan.SELECTORS.planCard) ||
        target.closest(TDProductSellingPlan.SELECTORS.mobileSelect)
      ) {
        return;
      }

      const schedule = this.firstExistingSubscription();
      if (schedule) this.applySelection('subscription', schedule);
    };

    handleChange = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.matches(TDProductSellingPlan.SELECTORS.purchaseOption)) {
        if (target.value === 'one_time') {
          this.applySelection('one_time');
        } else {
          const schedule = this.firstExistingSubscription();
          if (!schedule) return;
          this.applySelection('subscription', schedule);
        }
        return;
      }

      if (target.matches(TDProductSellingPlan.SELECTORS.scheduleOption)) {
        this.applySelection('subscription', target.value);
        return;
      }

      if (target.matches(TDProductSellingPlan.SELECTORS.mobileSelect)) {
        this.applySelection('subscription', target.value);
      }
    };

    handleBlockSelect = (event) => {
      if (!(event.target instanceof Element)) return;

      const perk = event.target.closest(TDProductSellingPlan.SELECTORS.perk);
      if (!perk || !this.contains(perk)) return;

      const appliesTo = perk.dataset.tdAppliesTo;
      const schedule = appliesTo === 'all' ? this.lastSchedule : appliesTo;
      if (this.plans[schedule]?.exists) this.applySelection('subscription', schedule);
    };

    handleFormInput = (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.matches(TDProductSellingPlan.SELECTORS.quantityInput)) return;
      this.updateMainCta(this.selectedAmount);
    };

    applySelection(purchase, schedule = this.lastSchedule) {
      const resolvedSchedule = this.plans[schedule]?.exists
        ? schedule
        : this.firstAvailableSubscription() || this.firstExistingSubscription();
      if (purchase === 'subscription' && !resolvedSchedule) return;
      if (purchase === 'one_time' && !this.plans.one_time.exists) return;

      if (resolvedSchedule) {
        schedule = resolvedSchedule;
        this.lastSchedule = resolvedSchedule;
      }

      this.querySelectorAll(TDProductSellingPlan.SELECTORS.purchaseOption).forEach((input) => {
        input.checked = input.value === purchase;
      });
      this.querySelectorAll(TDProductSellingPlan.SELECTORS.scheduleOption).forEach((input) => {
        input.checked = purchase === 'subscription' && input.value === schedule;
      });

      const mobileSelect = this.querySelector(TDProductSellingPlan.SELECTORS.mobileSelect);
      if (mobileSelect && this.plans[schedule]?.exists) mobileSelect.value = schedule;

      this.querySelector(TDProductSellingPlan.SELECTORS.oneTime)?.classList.toggle(
        'td-product-selling-plan__purchase--selected',
        purchase === 'one_time'
      );
      this.querySelector(TDProductSellingPlan.SELECTORS.subscription)?.classList.toggle(
        'td-product-selling-plan__subscription--selected',
        purchase === 'subscription'
      );
      this.querySelectorAll(TDProductSellingPlan.SELECTORS.planCard).forEach((card) => {
        card.classList.toggle(
          'td-product-selling-plan__plan--selected',
          purchase === 'subscription' && card.dataset.tdPlanKey === schedule
        );
      });

      if (resolvedSchedule) {
        this.updateSubscriptionSummary(schedule);
        this.updatePerks(schedule);
      }
      if (purchase === 'subscription') this.updateStartingLabel(schedule);
      this.updateForm(purchase, schedule);
    }

    updateStartingLabel(schedule) {
      const startingLabel = this.querySelector(TDProductSellingPlan.SELECTORS.startingLabel);
      if (!startingLabel) return;

      startingLabel.hidden = false;
      startingLabel.classList.toggle(
        'td-product-selling-plan__starting-label--hidden',
        schedule !== this.firstAvailableSubscription()
      );
    }

    updatePerks(schedule) {
      const plan = this.plans[schedule];
      this.querySelectorAll(TDProductSellingPlan.SELECTORS.perk).forEach((perk) => {
        const appliesTo = perk.dataset.tdAppliesTo;
        perk.hidden = appliesTo !== 'all' && appliesTo !== schedule;
        perk.querySelectorAll(TDProductSellingPlan.SELECTORS.perkCopy).forEach((copy) => {
          copy.innerHTML = this.interpolatePerkCopy(copy.dataset.tdPerkCopy || '', plan);
        });
      });
    }

    interpolatePerkCopy(copy, plan) {
      const comparePrice = this.compareAtPrice(plan);
      const recurringPrice = this.sellingPlanPrice(plan);
      const recurringDiscount = comparePrice > 0
        ? Math.round(((comparePrice - recurringPrice) / comparePrice) * 100)
        : 0;

      return copy
        .replaceAll('[recurring_discount]', `${recurringDiscount}%`)
        .replaceAll('[extra_discount]', this.formatMoney(this.discountAmount(plan.variant)));
    }

    updateSubscriptionSummary(key) {
      const plan = this.plans[key];
      const price = this.planPrice(plan);
      const comparePrice = this.compareAtPrice(plan);
      const saving = comparePrice > 0 ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;

      this.setText(TDProductSellingPlan.SELECTORS.subscriptionPrice, this.formatMoney(price));
      this.setText(TDProductSellingPlan.SELECTORS.subscriptionSuffix, plan.suffix);
      this.setText(TDProductSellingPlan.SELECTORS.mobileTitle, plan.title);
      this.setText(TDProductSellingPlan.SELECTORS.mobileSaving, `${saving}%`);
      this.setText(TDProductSellingPlan.SELECTORS.mobileDescription, plan.description);
    }

    updateForm(purchase, schedule) {
      const form = document.getElementById(this.dataset.tdProductFormId);
      const variantInput = form?.querySelector('input[name="id"]');
      const sellingPlanInput = this.querySelector(TDProductSellingPlan.SELECTORS.sellingPlanInput);
      const plan = purchase === 'one_time' ? this.plans.one_time : this.plans[schedule];

      if (variantInput && plan?.variant) variantInput.value = plan.variant.id;
      if (sellingPlanInput) {
        sellingPlanInput.value = purchase === 'subscription' ? plan.allocation.selling_plan_id : '';
      }

      if (plan?.available) {
        this.updateMainCta(
          purchase === 'subscription' ? this.planPrice(plan) : this.applyDiscountAmount(plan.variant, plan.variant.price)
        );
      } else {
        this.showSoldOutCta();
      }

      this.dispatchEvent(
        new CustomEvent('td:selling-plan:change', {
          bubbles: true,
          detail: {
            variant: plan?.variant || null,
            sellingPlanId: purchase === 'subscription' ? plan.allocation.selling_plan_id : null,
          },
        })
      );
    }

    updateMainCta(amount) {
      this.selectedAmount = Number(amount);

      const form = document.getElementById(this.dataset.tdProductFormId);
      const button = form?.querySelector(TDProductSellingPlan.SELECTORS.mainCta);
      const content = button?.querySelector(TDProductSellingPlan.SELECTORS.mainCtaContent);
      if (!button || !content || !Number.isFinite(this.selectedAmount)) return;

      if (button !== this.mainCtaButton) {
        this.restoreMainCta();
        this.mainCtaButton = button;
        this.mainCtaOriginalContent = content.cloneNode(true);
      }
      button.disabled = false;

      const quantity = Number(form.querySelector(TDProductSellingPlan.SELECTORS.quantityInput)?.value) || 1;
      const outerText = document.createElement('span');
      const desktopText = document.createElement('span');
      const mobileText = document.createElement('span');
      const desktopPrice = document.createElement('span');
      const mobilePrice = document.createElement('span');

      desktopText.className = 'td-product-selling-plan__cta-label td-product-selling-plan__cta-label--desktop';
      mobileText.className = 'td-product-selling-plan__cta-label td-product-selling-plan__cta-label--mobile';
      desktopPrice.className = 'td-product-selling-plan__cta-price';
      mobilePrice.className = 'td-product-selling-plan__cta-price';
      desktopPrice.textContent = this.formatMoney(this.selectedAmount * quantity);
      mobilePrice.textContent = desktopPrice.textContent;
      const showPrice = button.closest(TDProductSellingPlan.SELECTORS.mainCtaSettings)?.dataset.tdShowPrice !== 'false';
      if (!showPrice) {
        desktopText.textContent = this.dataset.tdAddToCartLabel;
        mobileText.textContent = this.dataset.tdAddToCartLabel;
      } else {
        desktopText.append(
          `${this.dataset.tdAddToCartLabel} | ${this.dataset.tdPayLabel} `,
          desktopPrice,
          ` ${this.dataset.tdTodayLabel}`
        );
        mobileText.append(
          `${this.dataset.tdAddToCartLabel} | `,
          mobilePrice,
          ` ${this.dataset.tdTodayLabel}`
        );
      }
      outerText.append(desktopText, mobileText);
      content.replaceChildren(outerText);
      button.classList.add('td-product-selling-plan__main-cta');
      button.style.setProperty('--td-selling-plan-cta-price', this.dataset.tdCtaPriceColor);
    }

    showSoldOutCta() {
      const form = document.getElementById(this.dataset.tdProductFormId);
      const button = form?.querySelector(TDProductSellingPlan.SELECTORS.mainCta);
      const content = button?.querySelector(TDProductSellingPlan.SELECTORS.mainCtaContent);
      if (!button || !content) return;

      if (button !== this.mainCtaButton) {
        this.restoreMainCta();
        this.mainCtaButton = button;
        this.mainCtaOriginalContent = content.cloneNode(true);
      }

      content.replaceChildren(document.createTextNode(this.dataset.tdSoldOutLabel || ''));
      button.classList.add('td-product-selling-plan__main-cta');
      button.style.removeProperty('--td-selling-plan-cta-price');
      button.disabled = true;
    }

    restoreMainCta() {
      if (!this.mainCtaButton || !this.mainCtaOriginalContent) return;

      const content = this.mainCtaButton.querySelector(TDProductSellingPlan.SELECTORS.mainCtaContent);
      if (content) {
        content.replaceChildren(...Array.from(this.mainCtaOriginalContent.childNodes, (node) => node.cloneNode(true)));
      }
      this.mainCtaButton.classList.remove('td-product-selling-plan__main-cta');
      this.mainCtaButton.style.removeProperty('--td-selling-plan-cta-price');
      this.mainCtaButton.disabled = false;
      this.mainCtaButton = undefined;
      this.mainCtaOriginalContent = undefined;
    }

    setText(selector, value) {
      this.querySelectorAll(selector).forEach((element) => {
        element.textContent = value;
      });
    }

    setDataText(selector, datasetKey, value, text) {
      this.querySelectorAll(selector).forEach((element) => {
        if (element.dataset[datasetKey] === value) element.textContent = text;
      });
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(this.dataset.tdLocale || 'en', {
        style: 'currency',
        currency: this.dataset.tdCurrency || 'EUR',
        maximumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2,
      }).format(Number(cents) / 100);
    }
  }

  if (!customElements.get('td-product-selling-plan')) {
    customElements.define('td-product-selling-plan', TDProductSellingPlan);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-quick-add-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-quick-add')) {
    class TDQuickAdd extends HTMLElement {
      #abortController = null;

      connectedCallback() {
        this.#abortController = new AbortController();
        this.querySelector('[data-td-quick-add-trigger]')?.addEventListener('click', this.#open, {
          signal: this.#abortController.signal,
        });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
        this.#abortController = null;
      }

      #open = () => {
        document.querySelector('td-quick-add-modal')?.open(this);
      };
    }

    customElements.define('td-quick-add', TDQuickAdd);
  }

  if (!customElements.get('td-quick-add-modal')) {
    class TDQuickAddModal extends HTMLElement {
      #abortController = null;
      #fetchController = null;
      #cache = new Map();
      #observer = null;
      #source = null;
      #previousFocus = null;
      #closeTimer = null;
      #scrollLocked = false;
      #scrollResetTimers = [];

      connectedCallback() {
        this.#abortController = new AbortController();
        this.dialog = this.querySelector('[data-td-quick-add-dialog]');
        this.scrollTarget = this.querySelector('[data-td-quick-add-scroll]');
        this.contentTarget = this.querySelector('.td-quick-add-modal__content');
        this.closeButton = this.querySelector('[data-td-quick-add-close]');
        this.imageTarget = this.querySelector('[data-td-quick-add-image]');
        this.summaryTarget = this.querySelector('[data-td-quick-add-summary]');
        this.buyingBoxTarget = this.querySelector('[data-td-quick-add-buying-box]');
        this.actionsTarget = this.querySelector('[data-td-quick-add-actions]');
        this.loading = this.querySelector('[data-td-quick-add-loading]');
        this.addButton = this.querySelector('[data-td-quick-add-add]');
        this.addToCart = this.addButton?.closest('add-to-cart-component');
        this.learnButton = this.querySelector('[data-td-quick-add-learn]');

        const { signal } = this.#abortController;
        this.closeButton?.addEventListener('click', this.close, { signal });
        document.addEventListener('click', this.#handleExternalTrigger, { signal });
        document.addEventListener('shopify:cart:lines-update', this.#handleCartUpdate, { signal });
        this.dialog?.addEventListener('cancel', this.#handleCancel, { signal });
        this.dialog?.addEventListener('click', this.#handleDialogClick, { signal });
        this.buyingBoxTarget?.addEventListener('change', this.#syncAddButton, { signal });
        this.buyingBoxTarget?.addEventListener('td:selling-plan:change', this.#syncAddButton, { signal });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
        this.#abortController = null;
        this.#fetchController?.abort();
        this.#observer?.disconnect();
        clearTimeout(this.#closeTimer);
        this.#scrollResetTimers.forEach(clearTimeout);
        this.#unlockScroll();
      }

      async open(source) {
        if (!this.dialog || !source) return;

        clearTimeout(this.#closeTimer);
        if (this.dialog.open) this.dialog.close();

        this.#source = source;
        this.#previousFocus = document.activeElement;
        this.#clearContent();
        this.learnButton.href = source.dataset.productUrl || '#';
        this.#copySummary(source);
        this.#lockScroll();
        this.dialog.showModal();
        this.dialog.dataset.tdState = 'open';
        this.#resetScroll();
        requestAnimationFrame(() => this.closeButton?.focus({ preventScroll: true }));
        await this.#loadBuyingBox(source.dataset.productUrl);
      }

      close = () => {
        if (!this.dialog?.open) return;
        this.#fetchController?.abort();
        this.dialog.dataset.tdState = 'closing';
        clearTimeout(this.#closeTimer);
        this.#closeTimer = setTimeout(() => {
          this.dialog.close();
          delete this.dialog.dataset.tdState;
          this.#clearContent();
          this.#unlockScroll();
          if (this.#previousFocus instanceof HTMLElement) this.#previousFocus.focus();
        }, 320);
      };

      #handleCancel = (event) => {
        event.preventDefault();
        this.close();
      };

      #handleDialogClick = (event) => {
        if (event.target === this.dialog) this.close();
      };

      #handleExternalTrigger = (event) => {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('[data-td-quick-add-external]');
        if (!(trigger instanceof HTMLElement)) return;

        const source = document.getElementById(trigger.dataset.tdQuickAddSourceId);
        if (!source) return;

        event.preventDefault();
        this.open(source);
      };

      #resetScroll() {
        this.#scrollResetTimers.forEach(clearTimeout);
        this.#scrollResetTimers = [0, 50, 150, 300, 600].map((delay) =>
          setTimeout(() => {
            if (this.scrollTarget) this.scrollTarget.scrollTop = 0;
            if (this.contentTarget) this.contentTarget.scrollTop = 0;
          }, delay)
        );
      }

      #lockScroll() {
        if (this.#scrollLocked) return;
        this.#scrollLocked = true;
        const scrollbarGap = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--td-quick-add-scrollbar-gap', `${scrollbarGap}px`);
        document.documentElement.classList.add('td-quick-add-scroll-locked');
      }

      #unlockScroll() {
        if (!this.#scrollLocked) return;
        this.#scrollLocked = false;
        document.documentElement.classList.remove('td-quick-add-scroll-locked');
      }

      #clearContent() {
        if (this.scrollTarget) this.scrollTarget.scrollTop = 0;
        if (this.contentTarget) this.contentTarget.scrollTop = 0;
        this.imageTarget?.replaceChildren();
        this.summaryTarget?.replaceChildren();
        this.buyingBoxTarget?.replaceChildren(this.loading);
        if (this.addButton) {
          this.addButton.disabled = true;
        }
        this.productForm?.remove();
        this.productForm = null;
        if (this.addToCart && this.actionsTarget && !this.actionsTarget.contains(this.addToCart)) {
          this.actionsTarget.prepend(this.addToCart);
        }
        this.#observer?.disconnect();
        this.#observer = null;
      }

      #copySummary(source) {
        const template = source.querySelector('[data-td-quick-add-template]');
        if (!template) return;

        const fragment = template.content.cloneNode(true);
        const image = fragment.querySelector('.td-quick-add__image');
        const summary = fragment.querySelector('.td-quick-add__summary');
        if (image) this.imageTarget.replaceChildren(image);
        if (summary) this.summaryTarget.replaceChildren(summary);
      }

      async #loadBuyingBox(productUrl) {
        if (!productUrl || !this.buyingBoxTarget) return;
        this.#fetchController?.abort();
        this.#fetchController = new AbortController();

        try {
          let details = this.#cache.get(productUrl);
          if (!details) {
            const response = await fetch(productUrl, {
              signal: this.#fetchController.signal,
              headers: { Accept: 'text/html' },
            });
            if (!response.ok) throw new Error(`Quick add fetch failed: ${response.status}`);

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            // The PDP markup is vendor-owned and fetched HTML cannot carry TD hooks.
            details = html.querySelector('td-product-selling-plan');
            if (details) this.#cache.set(productUrl, details.cloneNode(true));
          }

          if (!details) throw new Error('TD product selling plan was not found');
          const content = details.cloneNode(true);
          this.#connectForm(content);
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.warn('[td-quick-add] Unable to load PDP buying box:', error);
            this.buyingBoxTarget.replaceChildren();
          }
        } finally {
          this.#fetchController = null;
        }
      }

      #connectForm(content) {
        const formId = `TdQuickAddForm-${this.#source?.dataset.productId || Date.now()}`;
        const productData = content.querySelector('[data-td-product-data]')?.textContent;
        let product = null;

        try {
          product = productData ? JSON.parse(productData) : null;
        } catch (error) {
          console.warn('[td-quick-add] Invalid selling-plan product data:', error);
        }

        const variant = product?.variants?.[0];
        if (!variant) return;

        content.dataset.tdProductFormId = formId;
        content.dataset.tdAddToCartLabel = this.dataset.tdQuickAddCartLabel;
        content.dataset.tdKeepAddToCartLabel = 'true';
        content.querySelector('[data-td-selling-plan-input]')?.setAttribute('form', formId);

        const productForm = document.createElement('product-form-component');
        productForm.className = 'td-quick-add-modal__product-form';
        productForm.dataset.productId = this.#source?.dataset.productId || '';
        productForm.dataset.quantityDefault = '1';
        productForm.setAttribute('on:submit', '/handleSubmit');

        const liveRegion = document.createElement('div');
        liveRegion.className = 'visually-hidden';
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('role', 'status');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.setAttribute('ref', 'liveRegion');

        const form = document.createElement('form');
        form.id = formId;
        form.noValidate = true;
        form.setAttribute('data-type', 'add-to-cart-form');

        const variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        variantInput.value = variant.id;
        variantInput.setAttribute('ref', 'variantId');

        const quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        quantityInput.value = '1';

        const addToCart = this.addToCart;
        if (!addToCart || !this.actionsTarget) return;

        const media =
          variant.featured_media?.preview_image?.src ||
          product?.featured_media?.preview_image?.src ||
          this.imageTarget?.querySelector('img')?.currentSrc ||
          this.imageTarget?.querySelector('img')?.src ||
          '';
        addToCart.dataset.productVariantMedia = media;
        this.addButton.disabled = !variant.available;
        this.addButton.setAttribute('form', formId);

        form.append(variantInput, quantityInput, addToCart);
        productForm.append(liveRegion, form);
        this.productForm = productForm;
        this.buyingBoxTarget.replaceChildren(content);
        this.actionsTarget.prepend(productForm);

        this.#syncAddButton();
        this.#observer?.disconnect();
        this.#observer = new MutationObserver(this.#syncAddButton);
        this.#observer.observe(form, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
      }

      #syncAddButton = () => {
        const nativeButton = this.addButton;
        if (this.addButton) this.addButton.disabled = !nativeButton || nativeButton.disabled;
      };

      #handleCartUpdate = (event) => {
        if (event.action !== 'add' || event.target !== this.productForm) return;

        event.promise?.then(({ detail }) => {
          if (!detail?.didError) this.close();
        });
      };
    }

    customElements.define('td-quick-add-modal', TDQuickAddModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-review"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-review')) {
    class TDReview extends HTMLElement {
      static selectors = {
        trigger: '[data-td-review-trigger]',
      };

      connectedCallback() {
        this.trigger = this.querySelector(TDReview.selectors.trigger);

        if (!this.trigger) {
          return;
        }

        this.trigger.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.handleClick);
      }

      handleClick = () => {
        const targetSelector = this.trigger?.getAttribute('data-td-review-target');
        const target = targetSelector ? document.querySelector(targetSelector) : null;

        if (!target) {
          return;
        }

        const header = document.querySelector('header-component, header');
        const offset = header instanceof HTMLElement ? header.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({
          top,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });

        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
        }

        target.focus({ preventScroll: true });
      };
    }

    customElements.define('td-review', TDReview);
  }
  } catch(e) { console.error(e); }
})();

})();
